import { API_URL } from '../config';

let authFn = null;

export function setRetroAuth(fn) {
  authFn = fn;
}

export async function retroAuthFetch(path, init = {}) {
  const headers = { ...(init.headers || {}) };
  if (authFn) {
    Object.assign(headers, await authFn());
  }
  if (init.body instanceof FormData) {
    delete headers['Content-Type'];
  }
  const url = path.startsWith('http') ? path : `${API_URL}${path}`;
  return fetch(url, { ...init, headers });
}
